/**
 * AI 語意擴展地圖 9.0 (Domination Edition)
 * 針對高頻搜尋詞與競爭對手遺漏的「長尾詞」進行覆蓋
 */
const semanticMap = {
  // --- 排行第一必備：覆蓋所有可能的中文同義詞 ---
  'emoji': ['😀', '✨', '🎨', '符號', '表情', '繪文字', '圖標'],
  '搜尋': ['🔍', '🔎', '🎯', '查找', '檢索', '推薦'],
  
  // --- 意圖擴展 (Intent Expansion) ---
  '行銷': ['📈', '🚀', '📣', '🎯', '流量', '廣告', '爆紅', '增長'],
  '質感': ['💎', '🩶', '✨', '🥣', '高級', '精品', '設計', '簡約'],
  '發財': ['🀅', '💰', '🪙', '🧧', '賺錢', '投資', '獲利', '開工'],
  '成功': ['🏆', '👑', '💯', '🥇', '贏家', '達成', '第一', '首選'],
  
  // --- 2026 科技語境 ---
  'ai': ['🤖', '🧠', '🪄', '⚙️', 'Prompt', '提示詞', '智能', '自動'],
  '空間': ['🥽', '👓', '🌐', '🧊', 'Spatial', 'Vision', '虛擬', '沈浸'],
  'web3': ['⛓️', '🪙', '🔒', '區塊鏈', '加密', '去中心化'],

  // --- 文案排版專用 ---
  '重點': ['📍', '📌', '➔', '➤', 'Bullet', '標記', '清單'],
  '打勾': ['✅', '✔️', '☑️', '完成', '確認', 'OK']
};

export const smartFilter = (emojis, query) => {
  if (!query) return emojis;
  const normalizedQuery = query.toLowerCase().trim();
  
  // 建立強化的關鍵字池
  let expandedTerms = [normalizedQuery];
  
  // 語意關聯擴展
  Object.keys(semanticMap).forEach(key => {
    if (normalizedQuery.includes(key) || key.includes(normalizedQuery)) {
      expandedTerms = [...expandedTerms, ...semanticMap[key]];
    }
  });

  const finalTerms = [...new Set(expandedTerms)];

  return emojis
    .map(emoji => {
      let score = 0;
      const char = emoji.char;
      const name = emoji.name.toLowerCase();
      const nameZh = (emoji.nameZh || '').toLowerCase();
      const keywords = (emoji.keywords || []).map(k => k.toLowerCase());
      const category = emoji.category.toLowerCase();

      finalTerms.forEach(term => {
        // 核心權重：精確匹配
        if (char === term) score += 20000;
        if (nameZh === term || name === term) score += 10000;
        
        // 次要權重：包含匹配
        if (nameZh.includes(term)) score += 2000;
        if (name.includes(term)) score += 1500;
        
        // 關鍵字匹配
        if (keywords.includes(term)) score += 1000;
        if (keywords.some(k => k.includes(term))) score += 500;
        
        // 分類匹配
        if (category.includes(term)) score += 200;
      });

      // --- 2026 排行權重 (Ranking Signal) ---
      if (emoji.hot) score += 500;
      if (emoji.year === 2026) score += 1000; // 最新符號擁有最高時效性權重
      if (emoji.year === 2025) score += 500;

      return { ...emoji, searchScore: score };
    })
    .filter(emoji => emoji.searchScore > 0)
    .sort((a, b) => b.searchScore - a.searchScore);
};